import type { CoinView } from './model';

export function safeCoinLink(value: string | undefined) {
  if (!value) return null;
  try {
    const url = new URL(value);
    return (url.protocol === 'https:' || url.protocol === 'http:') &&
      !url.username &&
      !url.password
      ? url.href
      : null;
  } catch {
    return null;
  }
}

// Display-only fixture: never put invented addresses into live market DTOs or
// explorer URLs. A token keeps the same test address across cards and updates.
export function coinDisplayAddress(
  coin: Pick<CoinView, 'id' | 'address' | 'simulated'>,
) {
  if (!coin.simulated) return coin.address;
  let hash = 2166136261;
  for (const char of coin.id)
    hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
  const words = Array.from({ length: 5 }, (_, i) => {
    hash = Math.imul(hash ^ (i + 1), 16777619);
    return (hash >>> 0).toString(16).padStart(8, '0');
  });
  return '0x' + words.join('');
}
